import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import { type UserDetail } from '@/models/user';

import { meQueryKey } from './queryKeys';

/**
 * The signed-in user's own profile and the Grants they hold.
 *
 * One request, not two: admin-api folded the former self-permissions route into
 * this one, which answers with the same document as `GET /v1/users/{userId}`. The
 * route is auth-only — everyone may read themselves.
 */
export const getMe = async () => {
  const response = await api.get<UserDetail>('/v1/users/me');
  return response.data;
};

export const getMyPermissionsQueryOptions = () => ({
  queryKey: meQueryKey.all,
  queryFn: getMe,
});

// ponytail: plain useQuery — the endpoint is scoped to the session, not to a
// game/sandbox, and the Access area mounts above :sandboxCode where
// SandboxProvider isn't available.
export const useMyPermissions = () => useQuery(getMyPermissionsQueryOptions());
